<template>
  <div class="__total-data">
    {{ $t('global.text.displays') }} <strong>{{ totalCount }}</strong> {{ $t('global.text.data') }}
  </div>
</template>

<script>
export default {
  props: {
    totalCount: {
      type: Number,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.__total-data {
  color: $mep-color-text-400;
  margin: 0;
  margin-top: 20px;

  strong {
    font-weight: 600;
  }
}
</style>
